<template>
    <f7-page
        @page:beforein="pageBeforeIn"
        @page:afterin="pageAfterIn"
        :page-content="false"
        class="quiz-list-page">
        <nav-bar></nav-bar>
        <f7-page-content class="quiz-page-content">
            <!-- Search Section - Sticky Header -->
            <div class="search-section">
                <div class="search-box-wrapper">
                    <div class="search-input-group">
                        <i class="f7-icons if-not-md search-icon">search</i>
                        <input
                            type="text"
                            class="search-input"
                            v-model="searchKeyword"
                            placeholder="Tìm theo số thứ tự (#01, #02,...) hoặc tên bài thi..." />
                        <button
                            v-if="searchKeyword"
                            @click="searchKeyword = ''"
                            class="clear-search-btn"
                            type="button">
                            ✕
                        </button>
                    </div>
                </div>
            </div>

            <div class="main-container">
                <!-- Filter / Stats Bar -->
                <div class="stats-bar">
                    <div class="stats-text">
                        <span v-if="searchKeyword">
                            Kết quả tìm kiếm: "<strong>{{ searchKeyword }}</strong>"
                            (<strong>{{ filteredListQuiz.length }}</strong> bài)
                        </span>
                        <span v-else>
                            Danh sách bài kiểm tra (<strong>{{ listQuiz.length }}</strong> bài)
                        </span>
                    </div>
                </div>

                <!-- Empty Search State -->
                <div v-if="filteredListQuiz.length === 0" class="empty-state">
                    <div class="empty-icon">🔍</div>
                    <h3 class="empty-title">Không tìm thấy bài kiểm tra</h3>
                    <p class="empty-desc">
                        Không có bài kiểm tra nào phù hợp với từ khóa "<strong>{{ searchKeyword }}</strong>".
                    </p>
                    <button class="btn-reset-search" @click="searchKeyword = ''">
                        Xem tất cả bài kiểm tra
                    </button>
                </div>

                <!-- Quiz Cards Grid -->
                <div v-else class="quiz-grid">
                    <div
                        v-for="(item, index) in filteredListQuiz"
                        :key="item.id || index"
                        class="quiz-card-col">
                        
                        <div class="quiz-card">
                            <!-- Card Image -->
                            <div class="card-img-wrapper">
                                <img
                                    class="card-img"
                                    :src="item.quizImage || 'https://raw.githubusercontent.com/quangvietntd/media/refs/heads/main/logo_eic.png'"
                                    :alt="item.quizName"
                                    loading="lazy" />
                                
                                <!-- Badges Overlay -->
                                <div class="card-badges">
                                    <span class="badge badge-stt">
                                        #{{ item.sttDisplay }}
                                    </span>
                                    <span v-if="item.totalTime" class="badge badge-time">
                                        ⏱️ {{ item.totalTime }} phút
                                    </span>
                                    <span v-if="item.passGrade" class="badge badge-grade">
                                        🎯 Đạt: {{ item.passGrade }}/100
                                    </span>
                                </div>
                            </div>

                            <!-- Card Body -->
                            <div class="card-body">
                                <h2 class="quiz-title" :title="item.quizName">
                                    <span class="stt-tag">#{{ item.sttDisplay }}</span> {{ item.quizName }}
                                </h2>
                                
                                <p class="quiz-desc" :title="item.quizDescription">
                                    {{ item.quizDescription || 'Nhấn bắt đầu để tham gia làm bài kiểm tra trắc nghiệm kiến thức.' }}
                                </p>
                            </div>

                            <!-- Card Footer / Button -->
                            <div class="card-footer">
                                <f7-button
                                    :href="'/user-quiz/' + item.id + '/' + (item.totalTime || 60) + '/'"
                                    fill
                                    class="btn-start-quiz">
                                    <span>BẮT ĐẦU THI</span>
                                    <span class="arrow-icon">&rarr;</span>
                                </f7-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </f7-page-content>
    </f7-page>
</template>

<style scoped>
.quiz-list-page {
    background-color: #f1f5f9 !important;
}

.quiz-page-content {
    padding-top: var(--f7-navbar-height, 56px) !important;
    padding-bottom: 40px !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.main-container {
    max-width: 1250px;
    margin: 0 auto;
    padding-left: 14px;
    padding-right: 14px;
}

/* Search Section - Sticky Header */
.search-section {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 50;
    background: rgba(241, 245, 249, 0.95);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-bottom: 1px solid rgba(226, 232, 240, 0.9);
    box-shadow: 0 4px 12px -2px rgba(15, 23, 42, 0.05);
    padding: 10px 14px;
    width: 100%;
    box-sizing: border-box;
}

.search-box-wrapper {
    max-width: 1250px;
    margin: 0 auto;
    background: #ffffff;
    border-radius: 12px;
    padding: 3px 14px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    border: 1.5px solid #e2e8f0;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.search-box-wrapper:focus-within {
    border-color: #e0613d;
    box-shadow: 0 4px 16px rgba(224, 97, 61, 0.15);
}

.search-input-group {
    display: flex;
    align-items: center;
    position: relative;
}

.search-icon {
    color: #94a3b8;
    font-size: 18px;
    margin-right: 10px;
    flex-shrink: 0;
}

.search-input {
    flex: 1;
    height: 40px;
    border: none;
    outline: none;
    font-size: 14px;
    color: #1e293b;
    background: transparent;
    font-family: inherit;
    box-sizing: border-box;
}

.search-input::placeholder {
    color: #94a3b8;
    font-size: 14px;
}

.clear-search-btn {
    background: #f1f5f9;
    border: none;
    color: #64748b;
    border-radius: 50%;
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    cursor: pointer;
    flex-shrink: 0;
    transition: background 0.2s;
}

.clear-search-btn:hover {
    background: #e2e8f0;
    color: #0f172a;
}

/* Stats Bar */
.stats-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 4px 6px 4px;
    font-size: 13px;
    color: #64748b;
}

/* Empty State */
.empty-state {
    background: #ffffff;
    border-radius: 16px;
    padding: 48px 24px;
    text-align: center;
    border: 1px dashed #cbd5e1;
    margin: 20px auto;
    max-width: 500px;
}

.empty-icon {
    font-size: 44px;
    margin-bottom: 12px;
}

.empty-title {
    margin: 0 0 8px 0;
    font-size: 18px;
    font-weight: 700;
    color: #1e293b;
}

.empty-desc {
    margin: 0 0 20px 0;
    font-size: 14px;
    color: #64748b;
    line-height: 1.5;
}

.btn-reset-search {
    background: #e0613d;
    color: #ffffff;
    border: none;
    border-radius: 8px;
    padding: 10px 20px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(224, 97, 61, 0.25);
}

/* Quiz Cards Grid */
.quiz-grid {
    display: flex;
    flex-wrap: wrap;
    margin: -8px;
}

.quiz-card-col {
    width: 33.333333%;
    padding: 8px;
    box-sizing: border-box;
}

@media (min-width: 1200px) {
    .quiz-card-col {
        width: 33.333333%;
    }
}

@media (max-width: 991px) {
    .quiz-card-col {
        width: 50%;
    }
}

@media (max-width: 640px) {
    .quiz-card-col {
        width: 100%;
        padding: 6px 0;
    }
}

/* Quiz Card Component */
.quiz-card {
    background: #ffffff;
    border-radius: 14px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.quiz-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);
    border-color: #cbd5e1;
}

/* Card Image */
.card-img-wrapper {
    position: relative;
    width: 100%;
    height: 170px;
    background: #f8fafc;
    overflow: hidden;
}

.card-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.3s ease;
}

.quiz-card:hover .card-img {
    transform: scale(1.03);
}

.card-badges {
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
}

.badge {
    font-size: 11px;
    font-weight: 600;
    padding: 4px 8px;
    border-radius: 6px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(4px);
}

.badge-stt {
    background: linear-gradient(135deg, #e0613d 0%, #ea580c 100%);
    color: #ffffff;
    font-weight: 800;
    font-size: 11px;
    letter-spacing: 0.5px;
}

.stt-tag {
    display: inline-block;
    background: #e0f2fe;
    color: #0369a1;
    font-size: 13px;
    font-weight: 800;
    padding: 1px 6px;
    border-radius: 4px;
    margin-right: 4px;
    vertical-align: middle;
}

.badge-time {
    background-color: rgba(15, 23, 42, 0.75);
    color: #ffffff;
}

.badge-grade {
    background-color: rgba(14, 116, 144, 0.85);
    color: #ffffff;
}

/* Card Body */
.card-body {
    padding: 16px;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.quiz-title {
    margin: 0 0 8px 0;
    font-size: 17px;
    font-weight: 700;
    color: #0f2b5c;
    line-height: 1.35;
    text-transform: uppercase;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-height: 42px;
}

.quiz-desc {
    margin: 0;
    font-size: 13px;
    color: #64748b;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    flex: 1;
}

/* Card Footer */
.card-footer {
    padding: 14px 16px 16px 16px !important;
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
    justify-content: flex-start !important;
}

.btn-start-quiz {
    background-color: #e0613d !important;
    color: #ffffff !important;
    font-weight: 700 !important;
    border-radius: 8px !important;
    height: 42px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 14px !important;
    letter-spacing: 0.5px !important;
    box-shadow: 0 2px 8px rgba(224, 97, 61, 0.25) !important;
    transition: background 0.2s ease, box-shadow 0.2s ease !important;
}

.btn-start-quiz:hover {
    background-color: #c94e2b !important;
    box-shadow: 0 4px 12px rgba(224, 97, 61, 0.35) !important;
}

.arrow-icon {
    margin-left: 6px;
    font-size: 16px;
    transition: transform 0.2s ease;
}

.btn-start-quiz:hover .arrow-icon {
    transform: translateX(3px);
}

/* Mobile specific styling */
@media (max-width: 640px) {
    .card-img-wrapper {
        height: 140px;
    }

    .quiz-title {
        font-size: 16px;
        min-height: auto;
    }

    .card-body {
        padding: 12px 14px 10px 14px;
    }

    .card-footer {
        padding: 12px 14px 14px 14px !important;
    }

    .btn-start-quiz {
        height: 38px !important;
        font-size: 13px !important;
    }
}
</style>

<script>
    import axios from "axios";
    import apiEndpoint from '../../apiEndpoint';
    import NavBar from './NavBar.vue';
    export default {
        components : {
            NavBar
        },
        data() {
            return {
                apiUrl: apiEndpoint + "api/Quizzes",
                dataFromAPI: [],
                accessToken: "",
                listQuiz: [],
                searchKeyword: "",
                timeCount: 0,
                interval: ""
            };
        },
        computed: {
            filteredListQuiz() {
                if (!this.searchKeyword || !this.searchKeyword.trim()) {
                    return this.listQuiz;
                }
                const rawKw = this.searchKeyword.trim().toLowerCase();
                const cleanKw = rawKw.replace(/^#/, '').replace(/^(bài|bai|stt)\s*/i, '').trim();
                const numKw = parseInt(cleanKw, 10);

                return this.listQuiz.filter(item => {
                    // Match by number / STT (e.g. "1", "01", "#1", "#01", "bài 1")
                    if (!isNaN(numKw) && item.quizIndex === numKw) {
                        return true;
                    }
                    if (item.sttDisplay && (item.sttDisplay === cleanKw || item.sttDisplay.startsWith(cleanKw))) {
                        return true;
                    }
                    if (String(item.quizIndex).startsWith(cleanKw)) {
                        return true;
                    }
                    // Match by name or description
                    const name = (item.quizName || '').toLowerCase();
                    const desc = (item.quizDescription || '').toLowerCase();
                    return name.includes(rawKw) || desc.includes(rawKw);
                });
            }
        },
        methods : {
            setAxiosGlobal(token) {
                axios.defaults.headers = { 'Authorization': token };
            },
            pageBeforeIn: function (e, page) {
                const app = this.$f7;
                app.preloader.hide();
            },
            pageAfterIn: function (e, page) {
                const app = this.$f7;
                app.preloader.hide();
            },
            startTime() {
                this.interval = setInterval(function () {
                    this.timeCount++;
                }.bind(this), 1000);
            },
            stopTime() {
                clearInterval(this.interval);
            },
            async getListQuiz() {
                let filter = {where:{quizStatus: "ACTIVE"}}; // lọc danh sách bài trắc nghiệm
                try {
                    let data = await axios.get(this.apiUrl, {
                        params: {
                            filter: filter
                        }
                    });
                    this.dataFromAPI = (data.data || []).map((item, idx) => {
                        const num = idx + 1;
                        return {
                            ...item,
                            quizIndex: num,
                            sttDisplay: num < 10 ? `0${num}` : `${num}`
                        };
                    });
                } catch (error) {
                    console.log(error);
                }
            },
        },
        async created() {
            let token = localStorage.getItem('eic_quiz_tokenKey');
            this.setAxiosGlobal(token);
            await this.getListQuiz();
            this.listQuiz = this.dataFromAPI;
        }
    };
</script>
